import { AxiosInstance } from "axios";
import customAxios from "./interceptor";
import { ApiConfig } from "./types/apiConfig.type";
import { HttpMethod } from "./types/requestConfig.type";

export class ApiClient {
  private config: ApiConfig;
  private client: any;

  constructor(options: ApiConfig) {
    this.config = options;
    this.client = customAxios(this.config);
  }

  restApi = (axios: {
    get: (arg0: any, arg1: {}) => any;
    post: (arg0: any, arg1: any, arg2: {}) => any;
    put: (arg0: any, arg1: any, arg2: {}) => any;
    patch: (arg0: any, arg1: any, arg2: {}) => any;
    delete: (arg0: any, arg1: {}) => any;
  }) => ({
    get: (url: any, config = {}) => axios.get(url, config),
    post: (url: any, body: any, config = {}) => axios.post(url, body, config),
    put: (url: any, body: any, config = {}) => axios.put(url, body, config),
    patch: (url: any, body: any, config = {}) => axios.patch(url, body, config),
    delete: (url: any, config = {}) => axios.delete(url, config),
  });

  public api(): any {
    return this.restApi(this.client);
  }

  public isValidHttpMethod(value: HttpMethod): boolean {
    return Object.values(HttpMethod).includes(value);
  }
  public getAxiosInstance(): AxiosInstance {
    return this.client;
  }
}
